export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
    seriesError: 'Mindestens eine Option muss ausgewählt werden',
  },
  calculator: {
    title: 'Einsparungen im Walutomat berechnen',
    forBuy: 'für',
    unsupportedPair: 'Wir bieten derzeit keine Kurse für das ausgewählte Währungspaar an.',
    spinnerError: {
      generic: 'Beim Herunterladen der Daten ist ein Fehler aufgetreten',
      toManyRequests:
        'Der Rechner ist derzeit nicht verfügbar. Versuchen Sie es später noch einmal oder wenden Sie sich an den <a href="https://www.walutomat.com/de/kontakt/">Kundenservice</a>.',
    },
    commissionWT: 'Walutomat-Provision',
    ctaButton: 'Wechseln',
    amountText: 'Betrag',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title:
      'Überprüfen Sie die Kurse und{{nbsp}}tauschen Sie Währungen in{{nbsp}}Walutomat – schnell und{{nbsp}}günstig.',
    actualRate: 'Wechselkurs',
    buySelect: 'Ich kaufe',
    sellSelect: 'Verkaufen',
    exchangeAmountSellLabel: 'Sie erhalten',
    exchangeAmountBuyLabel: 'Einzahlung',
    commission: 'Werbe-Provision ({{commission}}%)',
  },
  formValidation: {
    emptyField: 'Das Feld darf nicht leer sein',
    requiredField: 'Das Feld ist Pflichtfeld',
    requireAllFields: 'Alle Felder müssen ausgefüllt werden',
    passwordToShort: 'Das Passwort muss 8 Zeichen lang sein',
    emailNotValid: 'Das Feld muss eine gültige E-Mail Adresse enthalten',
    emailReserved: 'Die E-Mail-Adresse ist bereits vergeben',
    emailUnregistered: 'Die E-Mail-Adresse wurde nicht in unserer Kundendatenbank gefunden.',
    markField: 'Markieren Sie mindestens eines der Kontrollkästchen',
    serverUnknownError: 'Kommunikationsfehler des Servers',
    invalidCharacters: 'Feld enthält ungültige Zeichen',
    phoneNotValid: 'Die Telefonnummer ist falsch',
    checkBoxBelow: 'Bitte kreuzen Sie das Feld unten an, um eine Nachricht zu senden',
    promocodeInvalid: 'Ungültiger Promocode',
    newsletterAlreadySubscribed: 'Diese E-Mail-Adresse ist bereits für den Newsletter angemeldet.',
  },
  password: {
    show: 'anzeigen',
    hide: 'ausblenden',
  },
  howItWorks: {
    showButton: 'Mehr anzeigen',
    hideButton: 'Weniger anzeigen',
  },
  rateCalculator: {
    baseInputLabel: 'Mam',
    counterInputLabel: 'Otrzymam',
    counterInputTooltip: 'Uwzględnia prowizję {{commission}}%',
    ctaAlert: 'Ustaw alert',
  },
  esim: {
    searchPlaceholder: 'Land oder Region suchen...',
    searchAriaLabel: 'Land oder Region suchen',
    searchMinChars: 'Geben Sie <b>mindestens 3 Zeichen</b> ein, um Ergebnisse anzuzeigen.',
    searchNoResults: '<b>Keine Ergebnisse.</b> Das gesuchte Land wurde nicht gefunden.',
    searchError: '<b>Ein Fehler ist aufgetreten.</b> Die Angebotsliste konnte nicht geladen werden.',
  },
  countries: {
    AD: 'Andorra',
    AE: 'Vereinigte Arabische Emirate',
    AF: 'Afghanistan',
    AG: 'Antigua und Barbuda',
    AI: 'Anguilla',
    AL: 'Albanien',
    AM: 'Armenien',
    AO: 'Angola',
    AQ: 'Antarktis',
    AR: 'Argentinien',
    AS: 'Amerikanisch-Samoa',
    AT: 'Österreich',
    AU: 'Australien',
    AW: 'Aruba',
    AX: 'Ålandinseln',
    AZ: 'Aserbaidschan',
    BA: 'Bosnien und Herzegowina',
    BB: 'Barbados',
    BD: 'Bangladesch',
    BE: 'Belgien',
    BF: 'Burkina Faso',
    BG: 'Bulgarien',
    BH: 'Bahrain',
    BI: 'Burundi',
    BJ: 'Benin',
    BL: 'Saint-Barthélemy',
    BM: 'Bermuda',
    BN: 'Brunei Darussalam',
    BO: 'Bolivien',
    BQ: 'Bonaire',
    BR: 'Brasilien',
    BS: 'Bahamas',
    BT: 'Bhutan',
    BV: 'Bouvetinsel',
    BW: 'Botswana',
    BY: 'Belarus',
    BZ: 'Belize',
    CA: 'Kanada',
    CC: 'Cocos-Inseln',
    CD: 'Demokratische Republik Kongo',
    CF: 'Zentralafrikanische Republik',
    CG: 'Kongo',
    CH: 'Schweiz',
    CI: 'Elfenbeinküste',
    CK: 'Cook-Inseln',
    CL: 'Chile',
    CM: 'Kamerun',
    CN: 'China',
    CO: 'Kolumbien',
    CR: 'Costa Rica',
    CU: 'Kuba',
    CV: 'Cabo Verde',
    CW: 'Curaçao',
    CX: 'Weihnachtsinsel',
    CY: 'Zypern',
    CZ: 'Tschechische Republik',
    DE: 'Deutschland',
    DJ: 'Dschibuti',
    DK: 'Dänemark',
    DM: 'Dominica',
    DO: 'Dominikanische Republik',
    DZ: 'Algerien',
    EC: 'Ecuador',
    EE: 'Estland',
    EG: 'Ägypten',
    EH: 'Westsahara',
    ER: 'Eritrea',
    ES: 'Spanien',
    ET: 'Äthiopien',
    FI: 'Finnland',
    FJ: 'Fidschi',
    FK: 'Falklandinseln',
    FM: 'Mikronesien',
    FO: 'Färöer Inseln',
    FR: 'Frankreich',
    GA: 'Gabun',
    GB: 'Vereinigtes Königreich',
    GD: 'Grenada',
    GE: 'Georgien',
    GF: 'Französisch-Guayana',
    GG: 'Guernsey',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GL: 'Grönland',
    GM: 'Gambia',
    GN: 'Guinea',
    GP: 'Guadeloupe',
    GQ: 'Äquatorialguinea',
    GR: 'Griechenland',
    GS: 'Südgeorgien und die Südlichen Sandwichinseln',
    GT: 'Guatemala',
    GU: 'Guam',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HK: 'Hongkong',
    HM: 'Heard-Insel und McDonald-Inseln',
    HN: 'Honduras',
    HR: 'Kroatien',
    HT: 'Haiti',
    HU: 'Ungarn',
    ID: 'Indonesien',
    IE: 'Irland',
    IL: 'Israel',
    IM: 'Isle of Man',
    IN: 'Indien',
    IO: 'Britisches Territorium im Indischen Ozean',
    IQ: 'Irak',
    IR: 'Iran',
    IS: 'Island',
    IT: 'Italien',
    JE: 'Jersey',
    JM: 'Jamaika',
    JO: 'Jordanien',
    JP: 'Japan',
    KE: 'Kenia',
    KG: 'Kirgisistan',
    KH: 'Kambodscha',
    KI: 'Kiribati',
    KM: 'Komoren-Inseln',
    KN: 'St. Kitts und Nevis',
    KP: 'Nordkorea',
    KR: 'Südkorea',
    KW: 'Kuwait',
    KY: 'Kaimaninseln',
    KZ: 'Kasachstan',
    LA: 'Laos',
    LB: 'Libanon',
    LC: 'St. Lucia',
    LI: 'Liechtenstein',
    LK: 'Sri Lanka',
    LR: 'Liberia',
    LS: 'Lesotho',
    LT: 'Litauen',
    LU: 'Luxemburg',
    LV: 'Lettland',
    LY: 'Libyen',
    MA: 'Marokko',
    MC: 'Monaco',
    MD: 'Moldawien',
    ME: 'Montenegro',
    MF: 'Saint-Martin',
    MG: 'Madagaskar',
    MH: 'Marshallinseln',
    MK: 'Nordmazedonien',
    ML: 'Mali',
    MM: 'Myanmar',
    MN: 'Mongolei',
    MO: 'Macau',
    MP: 'Nördliche Marianen',
    MQ: 'Martinique',
    MR: 'Mauretanien',
    MS: 'Montserrat',
    MT: 'Malta',
    MU: 'Mauritius',
    MV: 'Malediven',
    MW: 'Malawi',
    MX: 'Mexiko',
    MY: 'Malaysia',
    MZ: 'Mosambik',
    NA: 'Namibia',
    NC: 'Neukaledonien',
    NE: 'Niger',
    NF: 'Norfolk',
    NG: 'Nigeria',
    NI: 'Nicaragua',
    NL: 'Niederlande',
    NO: 'Norwegen',
    NP: 'Nepal',
    NR: 'Nauru',
    NU: 'Niue',
    NZ: 'Neuseeland',
    OM: 'Oman',
    PA: 'Panama',
    PE: 'Peru',
    PF: 'Französisch-Polynesien',
    PG: 'Papua-Neuguinea',
    PH: 'Philippinen',
    PK: 'Pakistan',
    PL: 'Polen',
    PM: 'Saint-Pierre und Miquelon',
    PN: 'Pitcairn',
    PR: 'Puerto Rico',
    PS: 'Palästina',
    PT: 'Portugal',
    PW: 'Palau',
    PY: 'Paraguay',
    QA: 'Katar',
    RE: 'Réunion',
    RO: 'Rumänien',
    RS: 'Serbien',
    RU: 'Russland',
    RW: 'Ruanda',
    SA: 'Saudi-Arabien',
    SB: 'Salomonen',
    SC: 'Seychellen',
    SD: 'Sudan',
    SE: 'Schweden',
    SG: 'Singapur',
    SH: 'St. Helena, Ascension und Tristan da Cunha',
    SI: 'Slowenien',
    SJ: 'Svalbard und Jan Mayen',
    SK: 'Slowakei',
    SL: 'Sierra Leone',
    SM: 'San Marino',
    SN: 'Senegal',
    SO: 'Somalia',
    SR: 'Suriname',
    SS: 'Südsudan',
    ST: 'São Tomé und Príncipe',
    SV: 'El Salvador',
    SX: 'Sint Maarten',
    SY: 'Syrien',
    SZ: 'Eswatini',
    TC: 'Turks- und Caicosinseln',
    TD: 'Tschad',
    TF: 'Französische Süd- und Antarktisgebiete',
    TG: 'Togo',
    TH: 'Thailand',
    TJ: 'Tadschikistan',
    TK: 'Tokelau',
    TL: 'Timor-Leste',
    TM: 'Turkmenistan',
    TN: 'Tunesien',
    TO: 'Tonga',
    TR: 'Türkei',
    TT: 'Trinidad und Tobago',
    TV: 'Tuvalu',
    TW: 'Taiwan',
    TZ: 'Tansania',
    UA: 'Ukraine',
    UG: 'Uganda',
    UM: 'Kleinere abgelegene Inseln der Vereinigten Staaten',
    US: 'Vereinigte Staaten',
    UY: 'Uruguay',
    UZ: 'Usbekistan',
    VA: 'Vatikan',
    VC: 'St. Vincent und die Grenadinen',
    VE: 'Venezuela',
    VG: 'Britische Jungferninseln',
    VI: 'Amerikanischen Jungferninseln',
    VN: 'Vietnam',
    VU: 'Vanuatu',
    WF: 'Wallis und Futuna',
    WS: 'Samoa',
    XK: 'Kosovo',
    YE: 'Jemen',
    YT: 'Mayotte',
    ZA: 'Südafrika',
    ZM: 'Sambia',
    ZW: 'Simbabwe',
  },
}
